import React from 'react';
import { motion } from 'framer-motion';
import modalidadeMusculacao from '../assets/images/modalidade_musculacao.jpeg';
import modalidadeFuncional from '../assets/images/modalidade_funcional.jpeg';
import modalidadeHidroginastica from '../assets/images/modalidade_hidroginastica.jpeg';
import modalidadeKarate from '../assets/images/modalidade_karate.jpeg';
import modalidadeRitbox from '../assets/images/modalidade_ritbox.png';
import modalidadeFitdance from '../assets/images/modalidade_fitdance.png';
import modalidadeNatacao from '../assets/images/modalidade_natacao.jpeg';
import modalidadeTenisMesa from '../assets/images/modalidade_tenis_mesa.jpeg';
import modalidadeMuaythai from '../assets/images/modalidade_muaythai.jpeg';
import modalidadeJiujitsu from '../assets/images/modalidade_jiujitsu.webp';

const Modalidades: React.FC = () => {
  // Animação para elementos que aparecem ao rolar
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  // Lista completa de modalidades
  const modalidades = [
    { 
      id: 1, 
      nome: 'Musculação', 
      imagem: modalidadeMusculacao,
      descricao: 'Treinamento com pesos e equipamentos para desenvolvimento muscular, força e resistência. Nossos instrutores criam planos personalizados para seus objetivos específicos.'
    },
    { 
      id: 2, 
      nome: 'Treinamento Funcional', 
      imagem: modalidadeFuncional,
      descricao: 'Exercícios que simulam movimentos do dia a dia, melhorando força, equilíbrio, coordenação e resistência de forma integrada e eficiente.'
    },
    { 
      id: 3, 
      nome: 'Hidroginástica', 
      imagem: modalidadeHidroginastica,
      descricao: 'Atividade física realizada na água que proporciona baixo impacto nas articulações, ideal para todas as idades e condições físicas.'
    },
    { 
      id: 4, 
      nome: 'Karatê', 
      imagem: modalidadeKarate,
      descricao: 'Arte marcial japonesa que desenvolve disciplina, concentração, respeito e condicionamento físico através de técnicas de defesa pessoal.'
    },
    { 
      id: 5, 
      nome: 'Ritbox', 
      imagem: modalidadeRitbox,
      descricao: 'Combinação de movimentos de artes marciais com ritmos musicais, proporcionando um treino cardiovascular intenso e divertido.'
    },
    { 
      id: 6, 
      nome: 'Fitdance', 
      imagem: modalidadeFitdance,
      descricao: 'Aulas de dança com coreografias modernas e animadas, que ajudam a queimar calorias enquanto você se diverte ao som de diversos ritmos.'
    },
    { 
      id: 7, 
      nome: 'Natação', 
      imagem: modalidadeNatacao,
      descricao: 'Atividade aquática completa que trabalha todos os grupos musculares, melhora o condicionamento cardiorrespiratório e proporciona bem-estar.'
    },
    { 
      id: 8, 
      nome: 'Tênis de Mesa', 
      imagem: modalidadeTenisMesa,
      descricao: 'Esporte que desenvolve reflexos, coordenação motora, concentração e estratégia, além de ser uma atividade social e recreativa.'
    },
    { 
      id: 9, 
      nome: 'Muay Thai', 
      imagem: modalidadeMuaythai,
      descricao: 'Arte marcial tailandesa que utiliza golpes de punhos, cotovelos, joelhos e pernas, proporcionando um excelente condicionamento físico.'
    },
    { 
      id: 10, 
      nome: 'Jiu Jitsu', 
      imagem: modalidadeJiujitsu,
      descricao: 'Arte marcial que foca em técnicas de alavancas, imobilizações e finalizações, desenvolvendo força, flexibilidade e resistência.'
    }
  ];

  return (
    <div className="pt-24 pb-20">
      <div className="container mx-auto px-4">
        {/* Header da página */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Nossas <span className="text-primary">Modalidades</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Na TopSpinFit, oferecemos uma ampla variedade de modalidades para todos os gostos e objetivos. 
            Conheça nossas opções e escolha a que melhor se adapta ao seu estilo de vida.
          </p>
        </motion.div>

        {/* Grid de modalidades */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {modalidades.map((modalidade, index) => (
            <motion.div
              key={modalidade.id}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              transition={{ delay: index * 0.1 }}
              className="card group h-full flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img 
                  src={modalidade.imagem} 
                  alt={modalidade.nome} 
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                  <h3 className="text-white text-2xl font-bold p-6">{modalidade.nome}</h3>
                </div>
              </div>
              <div className="p-6 bg-white flex-grow flex flex-col justify-between">
                <p className="text-gray-700 mb-4">{modalidade.descricao}</p>
                <div className="mt-auto">
                  <button className="text-secondary font-semibold hover:text-primary transition-colors flex items-center">
                    Ver horários
                    <svg 
                      className="w-5 h-5 ml-2" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24" 
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="mt-16 bg-secondary text-white p-8 md:p-12 rounded-lg text-center"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Quer experimentar alguma modalidade?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Oferecemos aula experimental gratuita para você conhecer nossas instalações e metodologia.
          </p>
          <button className="btn btn-primary text-lg">
            Agendar Aula Experimental
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Modalidades;
